import BasicTabs from "../src/components/launchpad";
import "./App.css";
import { Typography, Box } from "@mui/material";
import logo from "./assets/LoginLogo.svg";

function App() {
  return (
    <div className="App">
      {/* Logo Section */}
      <Box
        component="img"
        src={logo}
        alt="Launchpad Logo"
        sx={{
          width: { xs: "180px", sm: "230px", md: "280px" },
          display: "block",
          margin: "auto",
          mt: 1,
        }}
      />

      {/* Title */}
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
          textTransform: "uppercase",
          letterSpacing: { xs: 1, sm: 2 },
          // textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
          fontSize: "1.2rem",
          color: "#000000de",
        }}
      >
        Launchpad
      </Typography>

      {/* Tabs Section */}
      <BasicTabs />
    </div>
  );
}

export default App;
